module.exports = __webpack_public_path__ + "static/media/la.b09a5e8b.svg";